import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HelpDrawer from './HelpDrawer';
import { resolveHelpModuleId } from './helpModules';
import { useHelpTopicContext } from '@ui/contexts';
const HelpCenter = () => {
    const location = useLocation();
    const { isHelpDrawerOpen, closeHelpDrawer } = useHelpTopicContext();
    const moduleId = resolveHelpModuleId(location.pathname);
    useEffect(() => {
        closeHelpDrawer();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    return _jsx(HelpDrawer, { open: isHelpDrawerOpen, onClose: closeHelpDrawer, moduleId: moduleId });
};
export default HelpCenter;
